<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Guardian Info

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
        <div class="modal-body padding-top-0px">



          <ul class="nav nav-tabs nav-tab-service margin-top-13px" id="tabContent">
            <li class="active margin-right-30px"><a class="nav-item2 active" href="#details" data-toggle="tab">1.General</a></li>
            <li class="margin-right-30px"><a class="nav-item2" href="#address" data-toggle="tab">2.Address</a></li>
            <li><a class="nav-item2" href="#contact" data-toggle="tab">3.Contact</a></li>
          </ul>

          <div class="tab-content">
            <div class="tab-pane active" id="details">
              <div class="card card-guardian-159px">
                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                          General
                          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>

                        </div>-->
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="firstName"><span>*</span> Name </label>
                                </div>
                                <div class="col-md-3">

                                  <input type="text" class="form-control" id="CurrentActorEditGuardianInfoRequest.FirstName"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.FirstName"
                                         name="CurrentActorEditGuardianInfoRequest.FirstName" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                                         placeholder="First Name" maxlength="20" minlength="1" #FirstName="ngModel" required>
                                  <small class="form-text text-danger"
                                         *ngIf="(!FirstName.valid && (FirstName.dirty || FirstName.touched) && FirstName.errors.required )">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!FirstName.valid && FirstName.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                                <div class="col-md-3">

                                  <input type="text" class="form-control" id="CurrentActorEditGuardianInfoRequest.MiddleName"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.MiddleName"
                                         name="CurrentActorEditGuardianInfoRequest.MiddleName"
                                         placeholder="Middle Name" maxlength="20" pattern="^[\sa-zA-Z0-9,._\-?]*$" #MiddleName="ngModel">
                                  <small class="form-text text-danger"
                                         *ngIf="(!MiddleName.valid && MiddleName.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                                <div class="col-md-3">


                                  <input type="text" class="form-control" id="CurrentActorEditGuardianInfoRequest.LastName"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.LastName"
                                         name="CurrentActorEditGuardianInfoRequest.LastName"
                                         placeholder="Last Name" maxlength="20" minlength="1" #LastName="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
                                  <small class="form-text text-danger"
                                         *ngIf="(!LastName.valid && (LastName.dirty || LastName.touched) && LastName.errors.required)">(Field cannot be left blank)</small>
                                  <small class="form-text text-danger"
                                         *ngIf="(!LastName.valid && LastName.errors.pattern)">(special characters are not allowed)</small>

                                </div>
                              </div>

                            </div>
                          </div>


                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> Relationship</label>
                                </div>

                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="REL" id="CurrentActorEditGuardianInfoRequest.RelationShip"
                                                 [(ngModel)]="CurrentActorEditGuardianInfoRequest.RelationShip"
                                                 name="CurrentActorEditGuardianInfoRequest.RelationShip" SelectedValue="{{CurrentActorEditGuardianInfoRequest.RelationShip}}"></CodeTypeValue>

                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="card-footer text-align-center">
                  <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto" (click)="activeModal.close('Close click')">Close</button>
                </div>-->
              </div>

            </div>

            <div class="tab-pane" id="address">



              <div class="card">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                          Address
                          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>

                        </div>-->
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line1 </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Address Line1" id="CurrentActorEditGuardianInfoRequest.AddressLine1"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.AddressLine1"
                                         name="CurrentActorEditGuardianInfoRequest.AddressLine1" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine1="ngModel"
                                         maxlength="100" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!AddressLine1.valid && AddressLine1.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>
                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Address Line2 </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="Address Line2" id="CurrentActorEditGuardianInfoRequest.AddressLine2"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.AddressLine2"
                                         name="CurrentActorEditGuardianInfoRequest.AddressLine2" pattern="^[\sa-zA-Z0-9,._\-?]*$" #AddressLine2="ngModel"
                                         maxlength="100" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!AddressLine2.valid && AddressLine2.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>-->

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> City </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" placeholder="City" id="CurrentActorEditGuardianInfoRequest.City"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.City"
                                         name="CurrentActorEditGuardianInfoRequest.City"
                                         maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> State </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<CodeTypeValue CodeType="STATE" id="CurrentActorEditGuardianInfoRequest.State"
                                  [(ngModel)]="CurrentActorEditGuardianInfoRequest.State" SelectedValue="{{CurrentActorEditGuardianInfoRequest.State}}"
                                  name="CurrentActorEditGuardianInfoRequest.State"></CodeTypeValue>-->
                                  <input type="text" class="form-control" placeholder="State" id="CurrentActorEditGuardianInfoRequest.State"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.State"
                                         name="CurrentActorEditGuardianInfoRequest.State"
                                         maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #State="ngModel" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!State.valid && State.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> Country </label>
                                </div>
                                <div class="col-md-3">
                                  <!--<CodeTypeValue CodeType="STATE" id="CurrentActorEditGuardianInfoRequest.State"
                                  [(ngModel)]="CurrentActorEditGuardianInfoRequest.State" SelectedValue="{{CurrentActorEditGuardianInfoRequest.State}}"
                                  name="CurrentActorEditGuardianInfoRequest.State"></CodeTypeValue>-->
                                  <input type="text" class="form-control" placeholder="Country" id="CurrentActorEditGuardianInfoRequest.Country"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.Country"
                                         name="CurrentActorEditGuardianInfoRequest.Country"
                                         maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Country="ngModel" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!Country.valid && State.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>
                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Zip </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="text" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Zip"
                                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Zip"
                                         name="CurrentActorPersonalDetailInfoRequest.Zip" #Zip="ngModel" pattern="[0-9]{5}"
                                         placeholder="Zip" maxlength="5" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!Zip.valid && Zip.errors.pattern)">(special characters are not allowed)</small>
                                </div>
                              </div>


                            </div>
                          </div>-->


                        </div>
                      </div>






                    </div>

                  </div>

                </div>
              </div>




            </div>
            <div class="tab-pane" id="contact">



              <div class="card card-guardian-159px">

                <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-12 padding-l-0px">
                      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form padding-lr-0px">
                        <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
                          Contact
                          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime float-right">Save</button>
                        </div>-->
                        <div class="card-body card-body-general">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName"><span>*</span> Mobile Phone </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" placeholder="Mobile Phone" id="CurrentActorEditGuardianInfoRequest.Telephone1"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.Telephone1"
                                         mask="(000) 000-0000"
                                         name="CurrentActorEditGuardianInfoRequest.Telephone1" pattern="[0-9]{10}" #Telephone1="ngModel" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>
                                </div>
                              </div>


                            </div>
                          </div>
                          <!--<div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right">
                                  <label for="diaplayName">Telephone </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="tel" class="form-control" id="CurrentActorPersonalDetailInfoRequest.Telephone2"
                                         [(ngModel)]="CurrentActorPersonalDetailInfoRequest.Telephone2"
                                         mask="(000) 000-0000"
                                         name="CurrentActorPersonalDetailInfoRequest.Telephone2" pattern="[0-9]{10}" #Telephone2="ngModel"
                                         placeholder="Telephone" />
                                  <small class="form-text text-danger"
                                         *ngIf="(!Telephone2.valid)">(Provide Valid Phone No)</small>
                                </div>
                              </div>


                            </div>
                          </div>-->
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">

                                <div class="col-md-3 text-align-right">
                                  <label for="email address"><span>*</span> Email Address  </label>
                                </div>
                                <div class="col-md-3">
                                  <input type="email" class="form-control" placeholder="Email" id="CurrentActorEditGuardianInfoRequest.Email"
                                         [(ngModel)]="CurrentActorEditGuardianInfoRequest.Email"
                                         name="CurrentActorEditGuardianInfoRequest.Email"
                                         required pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$"
                                         #Email="ngModel" maxlength="30" minlength="4">
                                  <small class="form-text text-danger"
                                         *ngIf="(!Email.valid && (Email.dirty || Email.touched)  && Email.errors.required)">(Provide Valid Email)</small>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                    </div>
                  </div>

                </div>
              </div>





            </div>

          </div>



        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
          <button type="submit" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-13px">Save</button>
        </div>
      </form>
    </div>
  </div>
</div>
